











































































































































































































































































































































































































































































































import { Dodavatel } from '@/modules/ciselnik/skladove/dodavatel';
import { SkladMisto } from '@/modules/ciselnik/skladove/skladoveMisto';
import { RabatovaSkupina } from '@/modules/ciselnik/skladove/rabatovaSkupina';
import { ZboziDruh } from '@/modules/ciselnik/skladove/zbozidruh';
import { editFactory } from '@/main/pages';
import { apiProvider as ndCenikProvider } from '@/modules/sklad/ndCenik/api';
import { apiProvider as inventuraProvider } from '@/modules/sklad/inventura/api';
import { addPercentage, zaokrouhliNc } from '@/main/utils/numbers';
import { openEdit, openRouteAndReplace } from '@/main/router/routerPath';
import { router } from '@/main/router';
import { PageMode } from '@/main/utils/pageMode';
import { Status } from '@/main/store/@types/page';
import { MIO_PZN } from '@/modules/servis/zakazka/nahradniDily/constants';
import { ERROR } from '@/main/store/actionTypes';
import { NAME as ndObjednavkaName } from '@/modules/sklad/ndObjednavka/constants';
import { NAME as ZAKAZKA } from '@/modules/servis/zakazka/constants';
import { OZAKAZKA } from '@/modules/servis/constants';
import _ from 'lodash';
import dayjs from 'dayjs';
import { Partner } from '@/modules/kartoteka/partner';
import { NAME as ProOrderParts } from '@/modules/sklad/PROrders/parts/constants';
import { showAlert } from '@/main/utils/notifications';
import { formatDecimalValue } from '@/main/utils/stringHelper';

import { openList } from '@/main/router/routerPath';
import DmsPdfDialog from '#components/DmsPdfDialog.vue';

import Select from './components/Select.vue';

import CharakterSjDialog from './components/charakterSj/CharakterSjDialog.vue';
import { prepocetSj } from './components/charakterSj/utils';
import { PREPOCET_TYP } from './components/charakterSj/constants';
import { apiProvider } from './api';
import { store } from './store/edit';
import { AccessorTableEnum, DEPENDENT_TABLES, DMS_MODULE, NAME, POHYB_AUTOPRT, POHYB_MESICNI, POHYB_SKLAD, REFERENCE, PART_PRICING_LOG,
	Dealer, MENU_CODE, TAB_NAMES, TABS, BULK_ADJUSTMENT } from './constants';
import { editMutations, editActions } from './store/types';


export default editFactory(NAME, store).extend({
	components: {
		ZboziDruhSelect: ZboziDruh.components.Select,
		SkladMistoSelect: SkladMisto.components.Select,
		DodavatelSelect: Dodavatel.components.Select,
		RabatovaSkupinaSelect: RabatovaSkupina.components.Select,
		DmsPdfDialog,
		CharakterSjDialog,
		PartnerSelect: Partner.components.Select,
		NdSkladSelect: Select,
	},
	data() {
		return {
			apiProvider,
			pcKorekceDialogVisible: false,
			pcKorekceDialogVisibleStav: false,
			pcKorekcePromptDialogVisible: false,
			potvrzeniKorekceDialogVisible: false,
			newPc: 0 as number | null,
			novaKorekceStavu: 0 as number | null,
			disponibilitaZakazkaLoading: false,
			disponibilitaSkladCurrentRow: null,
			skladOznColumnId: '0',
			dialog: {
				visible: false,
				dialogLabelKye: 'frmDate',
			},
			conflictDialog: {
				visible: false,
				title: null as string | null,
				extraButtons: null as object | null,
				handleClose: () => { },
			},
			showKorekcePncReport: false,
			POHYB_SKLAD,
			POHYB_AUTOPRT,
			POHYB_MESICNI,
			REFERENCE,
			PART_PRICING_LOG,
			dependencies: DEPENDENT_TABLES,
			notificationDialog: {
				notificationDialogMsg: '',
				showNotificationDialog: false,
			},
			charakterSjDialogVisible: false,
			expiryDatePickerOptions: { disabledDate(time: Date) { return dayjs(time).isBefore(dayjs(Date.now())); } },
			visibleStalk: false,
			adjustmentReasonsForDrpDwn: [],
			isSpecsImgVisible: false,
			showNegativeHardReserve: false,
			tabNames: TAB_NAMES,
		};
	},
	mounted() {
		if (this.CustomerId) {
			this.conflictDialog.visible = true;
		}
		if (this.Oznam) {
			this.notificationDialog.notificationDialogMsg = this.Oznam;
			this.notificationDialog.showNotificationDialog = true;
		}
		if (this.props.defaultAction) this.defaultActiveTab();
	},
	computed: {
		tabItems() {
			const tabItems = [];

			if (this.hasTabAccess(MENU_CODE, TABS.Hlavni)) tabItems.push(TAB_NAMES.HLAVNI);
			if (this.hasTabAccess(MENU_CODE, TABS.Disponibilita)) tabItems.push(TAB_NAMES.DISPONIBILITA);
			if (this.hasTabAccess(MENU_CODE, TABS.SpcDisponibilita)) tabItems.push(TAB_NAMES.SPCDISPONIBILITA);
			if (this.hasTabAccess(MENU_CODE, TABS.ShodaNahradaND)) tabItems.push(TAB_NAMES.SHODANAHRADAND);
			if (this.hasTabAccess(MENU_CODE, TABS.Poznamka)) tabItems.push(TAB_NAMES.POZNAMKA);
			if (this.hasTabAccess(MENU_CODE, TABS.Inventura)) tabItems.push(TAB_NAMES.INVENTURA);
			if (this.hasTabAccess(MENU_CODE, TABS.Pohyby)) tabItems.push(TAB_NAMES.POHYBY);
			if (this.hasTabAccess(MENU_CODE, TABS.Reference)) tabItems.push(TAB_NAMES.REFERENCE);
			if (this.hasTabAccess(MENU_CODE, TABS.NDP)) tabItems.push(TAB_NAMES.NDP);
			if (this.hasTabAccess(MENU_CODE, TABS.WEIGHTEDAVG)) tabItems.push(TAB_NAMES.WEIGHTEDAVG);
			return _.pick(TABS, tabItems);
		},
		ndskladFilter(): any {
			return {
				NdNr: this.edit.SupersededPartNumber,
				SkladOzn: this.SkladOzn,
				Text: this.edit.SupersededPartText,
				VyrobekndOzn: null,
			};
		},
		notificationTitle(): string {
			return this.LocalizePopisostatni('Notification');
		},
		partsEnquiryPrpActive(): boolean {
			return Boolean(this.dmsSys.Parts_Enquiry_Prp);
		},
		isDisabledFirstStep(): boolean {
			return this.isPreparedNd && ((this.isCreateMode && this.disabledNdNrStep) || this.isEditMode || this.isViewMode);
		},
		isPreparedNd(): boolean {
			return !!this.NdNr && !!this.VyrobekndOzn && !!this.SkladOzn && !!this.DodavatelId;
		},
		mutationsMappers(): Record<string, string> {
			return {
				dodavatel: `${this.storeUri}/${editMutations.ND_SKLAD_DODAVATEL_SELECT_MAPPER}`,
				zboziDruh: `${this.storeUri}/${editMutations.ND_SKLAD_ZBOZI_DRUH_SELECT_MAPPER}`,
				skladMisto: `${this.storeUri}/${editMutations.ND_SKLAD_MISTO_SELECT_MAPPER}`,
				rabatSk: `${this.storeUri}/${editMutations.ND_SKLAD_RABAT_SK_SELECT_MAPPER}`,
				Customer: `${this.storeUri}/${editMutations.CUSTOMER_POJISTOVNA_FILTER_SELECT_MAPPER}`,
			};
		},
		actionsMapper(): Record<string, string> {
			return {
				ndSklad: `${this.storeUri}/${editActions.SUPERSEDED_PART_MAPPER}`,
			};
		},
		zboziDruhFilter(): { VyrobekndOzn: string | null } {
			return { VyrobekndOzn: this.VyrobekndOzn };
		},
		rabatSkFilter(): { VyrobekndOzn: string | null } {
			return { VyrobekndOzn: this.VyrobekndOzn };
		},
		skladmistoFilter(): { SkladOzn: number | null; VyrazenPrp: boolean } {
			return {
				SkladOzn: this.SkladOzn,
				VyrazenPrp: false,
			};
		},
		oductovatKorekciFilter(): { ndSkladId: number } {
			return {
				ndSkladId: this.ZaznamId!,
			};
		},
		dphSazba(): number {
			const dphSazba = (this.dropdownList.DphSzbOzn as any).find((e: any) => e.Value === this.DphSzbOzn);
			return dphSazba ? dphSazba.Sazba : 0;
		},
		ndsklPCsDPH(): number {
			return addPercentage(this.Pc!, this.dphSazba);
		},
		ndsklPCsGST(): number {
			return addPercentage(this.Pc!, this.GSTPercentage);
		},
		PcPncWithGST(): number {
			if (this.ndsklPCsGST > 0 && this.Pnc! > 0) {
				return this.ndsklPCsGST / this.Pnc!;
			}
			return 0;
		},
		pomerPcPnc(): number {
			if (this.ndsklPCsDPH > 0 && this.Pnc! > 0) {
				return this.ndsklPCsDPH / this.Pnc!;
			}
			return 0;
		},
		nezavislyPcsDph(): number {
			return addPercentage(this.newPc!, this.dphSazba);
		},
		newPriceWithGST(): number {
			return addPercentage(this.newPc!, this.GSTPercentage);
		},
		korekceStavuPrecision(): number {
			return (this.validationRules as { Stav: { scale: number } })?.Stav.scale;
		},
		isKontrolaBtnDisabled(): boolean {
			return this.isDisabledFirstStep || !this.isPreparedNd;
		},
		isInventoryAdjustmentSave(): boolean {
			return (this.AdjustmentType !== 1 && this.AdjustmentType !== 0)
				|| (this.AdjustmentReason === null || this.AdjustmentReason === 0)
				|| ((this.novaKorekceStavu! - this.AdjustmentQty!) < 0 && this.AdjustmentType === 1) || this.AdjustmentQty! < 0;
		},
		formattedLocalRRP(): string | null {
			return this.LocalRRP != null ? formatDecimalValue(this.LocalRRP) : this.LocalRRP;
		},
		formattedMovingAverage(): string | null {
			return this.MovingAverage != null ? formatDecimalValue(this.MovingAverage) : this.MovingAverage;
		},
		formattedWeightedAveragePrice(): string | null {
			return this.WeightedAveragePrice != null ? formatDecimalValue(this.WeightedAveragePrice) : this.WeightedAveragePrice;
		},
	},
	watch: {
		MaxHardReserveQty() {
			if (this.DisponibilitaSklad.rows.length > 0) {
				this.showNegativeHardReserve = false;
				if (this.MaxHardReserveQty! < 0) {
					this.showErrorAlert({
						message: this.LocalizeChyboveHlasky('NegativeValueNotAllowed'),
						options: { type: 'error' },
						localizeMessage: false,
					});
					this.MaxHardReserveQty = 0;
				}
				if (this.MaxHardReserveQty! > this.DisponibilitaSklad.rows[0].cells[2]) {
					this.showErrorAlert({
						message: this.LocalizeChyboveHlasky('hardReserveQty') + this.DisponibilitaSklad.rows[0].cells[2],
						options: { type: 'error' },
						localizeMessage: false,
					});
					this.MaxHardReserveQty = 0;
				}
			}
		},
		aktualniRok(newVal) {
			if (!newVal) {
				this.dialog.visible = true;
				this.vstupDatDo = new Date();
				const endDate = new Date();
				endDate.setFullYear(endDate.getFullYear() - 2);
				this.vstupDatOd = endDate;
			} else {
				this.refreshPodily();
			}
		},
		AdjustmentType(newVal) {
			if (newVal === null || newVal === undefined) this.adjustmentReasonsForDrpDwn = [];
			else {
				let tempitem: any;
				this.adjustmentReasonsForDrpDwn = [];
				this.dropdownList.AdjustmentReasons.filter((item) => {
					tempitem = item;
					if (tempitem.IsNegative === newVal && tempitem.Text !== BULK_ADJUSTMENT) this.adjustmentReasonsForDrpDwn.push(item);
					return this.adjustmentReasonsForDrpDwn;
				});
			}
			this.AdjustmentReason = null;
		},
	},
	methods: {
		defaultActiveTab() {
			this.activeTabName = this.tabNames.POHYBY;
			this.loadDefaultTables();
		},
		async loadDefaultTables() {
			this.edit.ZaznamId = this.props.id!;
			this.startLoading();
			await this.fetchTableSchemas(['PohybSkladKarta', 'PohybMesicniObrat', 'PohybAutopartObrat']);
			await this.fetchTableData(['PohybSkladKarta', 'PohybMesicniObrat', 'PohybAutopartObrat']);
			this.endLoading();
		},
		vyrobekndOznUpdate(VyrobekndOzn: string) {
			this.VyrobekndOzn = VyrobekndOzn;
			const vyrobekndOzn = this.dropdownList.VyrobekndOzn.find((item) => item.Value === VyrobekndOzn);
			this.DodavatelId = vyrobekndOzn?.DodavatelId ?? null;
			this.DodavatelIdText = vyrobekndOzn?.DodavatelIdText ?? null;
		},
		openCodealer() {
			openList(Dealer, { filter: { PartNumber: this.NdNr } });
		},
		handleValidation() {
			this.localState.identicalSupersededPart = false;
			this.localState.isDifferentWarehouse = false;
			this.edit.SupersededPartNumber = null;
			this.edit.SupersededPartId = null;
			this.edit.SupersededPartText = null;
		},
		async tabClicked(tab: any) {
			switch (tab.$props.name) {
				case TABS.Pohyby.id:
					this.startLoading();
					await this.fetchTableSchemas(['PohybSkladKarta', 'PohybMesicniObrat', 'PohybAutopartObrat']);
					await this.fetchTableData(['PohybSkladKarta', 'PohybMesicniObrat', 'PohybAutopartObrat']);
					this.endLoading();
					break;
				case TABS.Reference.id:
					this.startLoading();
					await this.fetchTableSchemas(['Reference']);
					await this.fetchTableData(['Reference']);
					this.endLoading();
					break;
				case TABS.NDP.id:
					this.startLoading();
					await this.fetchTableSchemas(['PartPricingLog']);
					await this.fetchTableData(['PartPricingLog']);
					this.endLoading();
					break;
				case TABS.Inventura.id:
					// Nothing to do
					break;
				case TABS.Poznamka.id:
					// Nothing to do
					break;
				case TABS.ShodaNahradaND.id:
					this.startLoading();
					await this.fetchTableSchemas(['NahradyPredchudce', 'NahradyNasledovnici', 'ShodaNd']);
					await this.fetchTableData(['NahradyPredchudce', 'NahradyNasledovnici', 'ShodaNd']);
					this.endLoading();
					break;
				case TABS.SpcDisponibilita.id:
					// Nothing to do
					break;
				case TABS.Disponibilita.id:
					this.startLoading();
					await this.skladTableSchema();
					await this.zakazkaTableSchema();
					await this.loadDisponibilitaSklad();
					this.endLoading();
					break;
				case TABS.Hlavni.id:
					// Nothing to do
					break;
				case TABS.WEIGHTEDAVG.id:
					this.startLoading();
					await this.fetchTableSchemas(['WeightedAverage']);
					await this.fetchTableData(['WeightedAverage']);
					this.endLoading();
					break;
				default:
					break;
			}
			this.endLoading();
		},

		onReasonUpdate(AdjustmentReason: number) {
			this.AdjustmentReason = AdjustmentReason;
		},
		async ChangesOrderType(input: string) {
			
			this.novaKorekceStavu = this.Stav;
		},
		refreshPodily() {
			if (this.aktualniRok) {
				this.vstupDatOd = dayjs().startOf('year').toDate();
				this.vstupDatDo = dayjs().endOf('year').toDate();
			}
			this.refreshTable(this.dependentTables.PohybSkladKarta.name);
			this.refreshTable(this.dependentTables.PohybAutopartObrat.name);
			this.refreshTable(this.dependentTables.PohybMesicniObrat.name);
			this.dialog.visible = false;
		},
		setPcKorekceDialogVisible() {
			this.newPc = this.Pc;
			this.pcKorekceDialogVisible = true;
		},
		async getDisponsibility() {
			const { data } = await apiProvider.disponsibilitaSPC({
				Ndnr: this.NdNr,
				Vyrobekndozn: this.VyrobekndOzn,
				Pocet: this.disponsibilitaDotaz,
				Skladozn: this.SkladOzn,
			});
			this.disponsibilitaResult = data.SpcPocet;
		},
		async setStavKorekceDialogVisible() {
			this.novaKorekceStavu = this.Stav;
			if (this.dmsSys.InventoryAdjustmentPrp) {
				this.startLoading();
				const inventoryExistsDetails = await apiProvider.inventoryAdjReqExists(this.ZaznamId!);
				this.endLoading();
				if (inventoryExistsDetails.data === true) {
					this.showErrorAlert({ message: this.LocalizeChyboveHlasky('AdjustReqExist').replace('<PartNo>', this.NdNr!), localizeMessage: false });
					return;
				}
			}
			this.pcKorekceDialogVisibleStav = true;
		},
		async changePcKorekce() {
			const isPokracovatConfirmed = this.dmsSys.EnableGSTPrp ? await this.showConfirmPokracovat(`
				<p> ${this.LocalizeChyboveHlasky('KorekceCenaInfo')} </p>
				<p> ${this.Localize('POC_CELK_OLD')}: ${this.Pc} </p>
				<p> ${this.Localize('POC_CELK_NEW')}: ${this.newPc} </p>
				<p> ${this.Localize('PC_WITH_GST')} ${this.newPriceWithGST.toFixed(2)} </p>
			`) : await this.showConfirmPokracovat(`
				<p> ${this.LocalizeChyboveHlasky('KorekceCenaInfo')} </p>
				<p> ${this.Localize('POC_CELK_OLD')}: ${this.Pc} </p>
				<p> ${this.Localize('POC_CELK_NEW')}: ${this.newPc} </p>
				<p> ${this.Localize('X_PC_VC_DPH')} ${this.nezavislyPcsDph.toFixed(2)} </p>
			`);

			if (isPokracovatConfirmed) {
				this.pcKorekceDialogVisible = false;
				this.Pc = this.newPc;
				this.Kdc = (
					await ndCenikProvider.kdc({
						VyrobekndOzn: this.VyrobekndOzn,
						NdNr: this.NdNr,
						SkladOzn: this.SkladOzn,
					})
				).data;
			}
		},
		async changeKorekceStavu() {
			this.showAllDialogueAfterstalk();
		},
		async showAllDialogueAfterstalk() {
			this.visibleStalk = false;
			const quantity  = this.Stav!;
			if ((this.AdjustmentType === 1) && ((quantity === null ? 0 : quantity) - this.AdjustmentQty!) < 0) {
				this.showErrorAlert({ message: this.LocalizeChyboveHlasky('AdjustQtyLessThanAvaQty'), options: { type: 'error' }, localizeMessage: false });
				return;
			}
			
			if (this.dmsSys.InventoryAdjustmentPrp) {
				if (this.AdjustmentQty === null || this.AdjustmentQty === 0) {
					this.showErrorAlert({ message: this.LocalizeChyboveHlasky('AdjustmentQtyNullOrZero'), localizeMessage: false });
					return;
				}
				if ((this.AdjustmentType === 1) && ((this.novaKorekceStavu === null ? 0 : this.novaKorekceStavu) - this.AdjustmentQty) < 0) {
					this.showErrorAlert({ message: this.LocalizeChyboveHlasky('AdjustQtyLessThanAvaQty'), options: { type: 'error' }, localizeMessage: false });
					return;
				}
				if (((this.AdjustmentType === 1 && quantity >= this.AdjustmentQty) || this.AdjustmentType === 0) && this.AdjustmentQty > 0) {
					if (this.AdjustmentReason === 0 || this.AdjustmentReason === null) {
						this.showErrorAlert({ message: this.LocalizeChyboveHlasky('AdjustmentReasonMandatory'), localizeMessage: false });
						return;
					}
					const korekceData = {
						PartRecId: this.ZaznamId,
						PartNo: this.NdNr,
						Stav: this.Stav,
						AdjustmentQty: this.AdjustmentQty,
						AdjustmentType: this.AdjustmentType,
						ReqReasonId: this.AdjustmentReason,
						RequestStatusId: 2,
						RequestRejectionCommt: this.RequestRejectionCommt,
						CreatedById: this.pracovnik.PracovnikId,
						UpdatedById: this.pracovnik.PracovnikId,
						OrderType: this.OrderType
					};
					this.pcKorekceDialogVisibleStav = false;
					this.startLoading();
					const { data: invAdjustmentresp } = await apiProvider.inventoryAdjusments(korekceData);
					if (invAdjustmentresp === 1) {
						const emailDto = {
							ReceiverId: this.pracovnik.PracovnikId,
							PartNo: this.NdNr,
						};
						await apiProvider.sendEmailNotification(emailDto);
					}
					if (invAdjustmentresp === -1) {
						this.showErrorAlert({ message: this.LocalizeChyboveHlasky('AdjustQtyLessThanAvaQty'), options: { type: 'error' }, localizeMessage: false });
					}
					this.endLoading();

					const NotificationObj = {
						SenderId: this.pracovnik.PracovnikId,
						ReceiverId: this.pracovnik.PracovnikId,
						NotificationMsg: this.LocalizeAndReplace(this.LocalizeChyboveHlasky('InvAdjSubmitted'), { key: '<ND_NE>', value: this.NdNr! }),
					};
					await apiProvider.sendNotification(NotificationObj);
				}
			} else if (this.Stav !== this.novaKorekceStavu && this.novaKorekceStavu! >= 0) {
				const isPokracovatConfirmed = await this.showConfirmPokracovat(`
					<p> ${this.LocalizeChyboveHlasky('ZmenaStavSklad')} </p>
				`);

				if (isPokracovatConfirmed) {
					const korekceDuvodDefaultValue = `${this.Localize('korDuvod')}...`;
					this.showConfirm({
						message: this.LocalizeChyboveHlasky('KorekceStavSkladInfo'),
						title: this.LocalizeChyboveHlasky('KorekceStav'),
						options: {
							inputType: 'text',
							inputValue: '',
							inputPlaceholder: korekceDuvodDefaultValue,
							showInput: true,
							cancelButtonText: this.Localize('cmdStorno'),
							confirmButtonText: this.Localize('Ok'),
							callback: async (action, { inputValue }) => {
								if (action === 'confirm' && inputValue !== korekceDuvodDefaultValue) {
									this.pcKorekceDialogVisibleStav = false;
									this.Stav = this.novaKorekceStavu;
									const korekceData = {
										SkladOzn: this.SkladOzn,
										Vyrobeknd_ozn: this.VyrobekndOzn,
										NdNr: this.NdNr,
										Stav: this.Stav,
										Duvod: inputValue,
									};
									await this.korekceStavu({ korekceData, isCreateMode: this.isCreateMode });
									if (this.isCreateMode && this.ZaznamId) {
										openRouteAndReplace(NAME, PageMode.EDIT, { id: this.ZaznamId });
									}
								}
							},
						},
					});
				}
			}
		},
		disponibilitaSkladRowSeleted(cells: any) {
			this.loadDisponibilitaZakazka(cells[this.skladOznColumnId]);
		},
		loadDisponibilitaSklad() {
			this.skladTableData({
				filter: {
					VyrobekndOzn: this.VyrobekndOzn,
					NdNr: this.NdNr,
					SkladOzn: this.SkladOzn,
				},
			}).then(() => {
				if (this.DisponibilitaSklad.rows.length > 0) {
					const columnId = this.skladOznColumnId;
					this.disponibilitaSkladCurrentRow = this.DisponibilitaSklad.rows[0].cells[columnId as any];
					this.loadDisponibilitaZakazka(this.disponibilitaSkladCurrentRow);
				}
			});
		},
		loadDisponibilitaZakazka(skladOzn: number | null) {
			this.disponibilitaZakazkaLoading = true;
			this.zakazkaTableData({
				VyrobekndOzn: this.VyrobekndOzn,
				NdNr: this.NdNr,
				SkladOzn: skladOzn,
			});
		},
		async loadData() {
			this.startLoading();
			if (this.isCreateMode) {
				this.default();
			} else {
				await this.entity();
				// this.fetchTableSchemas();
				// this.skladTableSchema();
				// this.zakazkaTableSchema();

				// this.fetchTableData();
				// this.loadDisponibilitaSklad();
			}
			if (!this.mainCollapse.length) {
				this.mainCollapse.push(POHYB_SKLAD);
			}
			this.endLoading();
			if (this.ExpiryDat === null) {
				showAlert({
					message: this.LocalizeChyboveHlasky('PartExpiryDate'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: { type: 'info' },
				});
			}
		},
		onSkOClick() {
			this.openNdObjednavkaEdit(MIO_PZN.SKO);
		},
		createReminders() {
			this.conflictDialog.visible = true;
			(this.validationRules as { InquiredQuantity: { required: boolean } }).InquiredQuantity.required = true;
		},
		async saveSparePartReminder() {
			this.startLoading();
			const sparePart = {
				CustomerName: this.CustomerName,
				CustomerEmail: this.CustomerEmali,
				CustomerPhone: this.CustomerPhone,
				Quantity: this.PartQty,
				PartNumber: this.NdNr,
				AvailabilityDateTime: this.AvailabilityDate,
			};
			const result = await this.saveSparePartReminders({ sparePart });
			if (result !== 0) {
				this.conflictDialog.visible = false;
				this.endLoading();
				this.refreshPage();
				this.CustomerId = null;
				this.CustomerEmali = null;
				this.CustomerPhone = null;
				this.PartQty = null;
			}
			this.endLoading();
			this.refreshPage();
		},
		onRyONaSkladClick() {
			this.openNdObjednavkaEdit(MIO_PZN.RYO);
		},
		openNdObjednavkaEdit(MioPzn: number) {
			if (this.loggedUser.DmsSys.PROrdersPrp) {
				openEdit(ProOrderParts, PageMode.CREATE, { filter: { VyrobekndOzn: this.VyrobekndOzn, NdNr: this.NdNr, SkladOzn: this.SkladOzn, MioPzn } });
			} else {
				openEdit(ndObjednavkaName, PageMode.CREATE, {
					filter: { VyrobekndOzn: this.VyrobekndOzn, NdNr: this.NdNr, SkladOzn: this.SkladOzn, MioPzn },
				});
			}
		},
		async onKontrolaNdBtnclick() {
			if (!this.isPreparedNd) return;
			try {
				this.startLoading();
				await this.checkIfNdExists();
				if (!_.isNil(this.ZaznamId) && this.ZaznamId > 0) {
					await this.changeUrlToEdit(this.ZaznamId!);
				} else {
					const resp = await ndCenikProvider.entityByKey({ vyrobekndOzn: this.VyrobekndOzn, ndNr: this.NdNr });
					if (!resp || (_.isArray(resp) && resp.length === 0)) router.back();
					this[editMutations.ND_SKLAD_CREATE_KONTROLA_ND_MAPPER](resp);
				}
			} catch (err) {
				this.$store.dispatch(ERROR, { err, moduleKey: DMS_MODULE }, { root: true });
			} finally {
				this.disabledNdNrStep = this.isPreparedNd;
				this.endLoading();
			}
		},
		async oductovatKorekciPncPdfProvider() {
			return inventuraProvider
				.oductovatKorekciPnc({ ndSkladId: this.ZaznamId! })
				.catch((err) => {
					this.$store.dispatch(ERROR, { err, moduleKey: DMS_MODULE }, { root: true });
					this.showKorekcePncReport = false;
				})
				.finally(() => {
					this.loadData();
				});
		},
		async oductovatPncKorekci() {
			if (this.PncKorekce !== 0) {
				const isPokracovatConfirmed = await this.showConfirmPokracovat(
					`
					<p> ${this.LocalizeChyboveHlasky('OductovaniPNCDotaz')} </p>
				`,
					false,
				);
				if (isPokracovatConfirmed) {
					this.showKorekcePncReport = true;
				}
			}
		},
		openZakazka({ data }: { data: Record<string, any> }) {
			const { ID, TABLE_ENUM } = data;
			const name = TABLE_ENUM === AccessorTableEnum.Zakazka ? ZAKAZKA : OZAKAZKA;
			openEdit(name, PageMode.EDIT, { id: ID });
		},
		prepoctiSj(SkladMjId: number, VydejMjId: number, VydejMjPoc: number, PrepocetTyp: PREPOCET_TYP) {
			if (PrepocetTyp === PREPOCET_TYP.CHARAKTER_SJ) {
				this.Stav = zaokrouhliNc(prepocetSj(this.VydejMjPoc!, VydejMjPoc, this.Stav!, true), 3);
				this.Pc = zaokrouhliNc(prepocetSj(this.VydejMjPoc!, VydejMjPoc, this.Pc!, false), 2);
				this.Pnc = zaokrouhliNc(prepocetSj(this.VydejMjPoc!, VydejMjPoc, this.Pnc!, false), 3);
			}
			this.SkladMjId = SkladMjId;
			this.VydejMjId = VydejMjId;
			this.VydejMjPoc = VydejMjPoc;

			this.charakterSjDialogVisible = false;
		},
		async deleteClick() {
			this.startLoading();

			const { ZaznamId, NdNr, VyrobekndOzn, SkladOzn }: any = this.layoutProps.model;
			const { data: response } = await apiProvider.deletePart(ZaznamId, NdNr, VyrobekndOzn, SkladOzn);

			if (response.Value) {
				this.endLoading();
				this.$router.go(-1);
			}
			this.endLoading();
		},
		onUpdatePartNumber(val: string | null) {
			this.edit.SupersededPartText = null;
			this.edit.SupersededPartId = null;
			this.edit.SupersededPartNumber = val;
		},
		onObsoleteChange(val: boolean) {
			if (!val || val === null || val === undefined) {
				this.edit.SupersededPartText = null;
				this.edit.SupersededPartId = null;
				this.edit.SupersededPartNumber = null;
			}
		},
	},
});
